export const AUTH_STORE = 'auth_store';